import pink from "./pink.png";
import purple from "./purple.png";
import yellow from "./yellow.png";
import lighty from "./light-yellow.png";

const db = () => {
  return {
    products: [
      {
        name: "Dylan Blue by Versace Eau De Toilette Spray 6.7 Oz (Pack of 5)",
        rating: 4.5,
        description:
          "Dylan Blue by Versace Eau De Toilette Spray 6.7 oz (Pack of 5) condition: New Brand: Versace MPN: Does not apply.",
        ingredients: null,
        image: "https://images.barcodelookup.com/15112/151129881-1.jpg",
        onlineStores: null,
        upc: "818253779570",
        classifications: ["Personal Care", "Cosmetics", "Perfume & Cologne"],
        found: true,
      },
      {
        name: "Tropicana Pure Premium 100% Orange Juice Original, No Pulp, No Sugar Added, 46 Fl Oz",
        rating : 4.5,
        description: "Tropicana Pure Premium 100% Orange Juice Original with no pulp and no added sugar offers a refreshing and healthy option packed with vitamins.",
        ingredients: null,
        image: "https://images.barcodelookup.com/120459/1204592003-1.jpg",
        onlineStores: null,
        upc: "048500205716",
        classifications: ["Juice"],
        found : true,
      },
      {
        name: "Tropicana Refreshers, Tropical Punch, 46 Fl Oz Bottle",
        rating : 4.5,
        description: "",
        ingredients: null,
        image: "https://images.barcodelookup.com/124332/1243322344-1.jpg",
        onlineStores: null,
        upc: "48500205853",
        classifications: ["Juice"],
        found : true,
      },
      {
        name: "CeraVe Hydrating Face Wash | 16 Ounce | Daily Facial Cleanser for Dry Skin | Fragrance-Free",
        rating : 4.5,
        description: "Developed with dermatologists CeraVe Hydrating Facial Cleanser is a unique formula that cleanses hydrates and helps restore the protective skin barrier with three essential ceramides (1 3 6-II). The formula also contains hyaluronic acid to help retain skin?s natural moisture.",
        ingredients: null,
        image: "https://images.barcodelookup.com/20245/202451348-1.jpg",
        onlineStores: null,
        upc: "691035387039",
        classifications: ["Personal Care"],
        found : true,
      },
      {
        name: "CeraVe Moisturizing Lotion 12 Oz (Pack of 9)",
        rating : 4.5,
        description: "CeraVe Moisturizing Lotion 12 oz (Pack of 9) condition: New Brand: CeraVe MPN: Does not apply Code: 681-561225000231763.",
        ingredients: null,
        image: "https://images.barcodelookup.com/11112/111124712-1.jpg",
        onlineStores: null,
        upc: "696545186097",
        classifications: ["Personal Care"],
        found : true,
      },
      {
        name: "Sephora Collection Cream Lip Shine Lippenstift, 15 Plum Energy, Energy",
        rating : 4.5,
        description: "Ein unglaublich glnzender Flssiglippenstift in 10 intensiven, trendigen Farben, die Glanz, langen Halt und Przision kombinieren fr ein sinnliches Lippen-Make-up. Nach dem legendren matten Cream Lip Stain bringt die SEPHORA COLLECTION eine neue Kollektion mit 10 hochpigmentierten Flssiglippenstiften heraus, die deinen Lippen unglaublichen Glanz verleihen. Fr welche Art von Make-up? Intensitt Farbe mit langem Halt und Glanz, kombiniert in einem einzigen Produkt, um deine Lippen mit einem Strich zu verschnern. Mit einer Reihe von Nude-, Rosa- und Rottnen wurde diese Kollektion mit 10 Nuancen entwickelt, um dich zu begeistern: Egal, in welcher Stimmung du bist. Unterscheidungsmerkmale: Intensive hochpigmentierte Farbe mit langem Halt Spiegelglanz Cremige angenehme Textur mit hoher Deckkraft.",
        ingredients: null,
        image: "https://images.barcodelookup.com/22017/220177110-1.jpg",
        onlineStores: null,
        upc: "3378872129776",
        classifications: ["Makeup"],
        found : true,
      },
      {
        name: "Lucky Charms Cereal - 14.9 Oz",
        rating : 4.5,
        description: "Made with 11g of whole grain per serving; and it's Gluten Free All you need to start your day off right is a little bit of magic, and lucky for you, Lucky Charms marshmallows are pretty magical Hearts, stars, and horseshoes, clovers and blue moons, unicorns, rainbows, and tasty red balloons all make Lucky Charms magically delicious.",
        ingredients: null,
        image: "https://images.barcodelookup.com/9552/95524429-1.jpg",
        onlineStores: null,
        upc: "016000124998",
        classifications: ["Cereal"],
        found : true,
      }

      /*
      {
        name: "Tropicana Orange Juice - 12/15.2 Oz. Bottles by Tropicana",
        rating: 4.5,
        image: "https://images.barcodelookup.com/5020/50203946-1.jpg",
        upc: "794653660444",
        classifications: ["test", "test"],
        found: true,
      },
      {
        name: "Factory-Reconditioned Milwaukee 6460-8 15 Amp 10-1/4 Inch Circular Saw",
        rating: 4.5,
        description: null,
        ingredients: null,
        image: "https://images.barcodelookup.com/5359/53591419-1.jpg",
        onlineStores: null,
        upc: "045242991617",
        classifications: ["Tools", "Saws", "Hand Saws"],
        found: true,
      },
      {
        name: 'Rockville Powered 15" Karaoke System/Pro Machine 4 iPad/iPhone/Android/Laptop/TV',
        rating: 4.5,
        description:
          "Introducing Rockvilles New YouTubeKaraoke System. Weall have Phones & iPads/Tablets. Rockvilles new YouTube karaoke system willallow you to use your existing devices to create a powerful and amazing karaokeexperience. You simply take all available content from YouTube and play it backon a professional sounding karaoke speaker while interfacing with any of yourexisting devices to view the words to the songs on a screen of your choice(tablet, laptop, iPhone, etc). It has Bluetooth built in allowing you towirelessly stream the music from your iPad or Bluetooth phone to the speaker.Karaoke Made simple:Gettingstarted takes less than 2 minutes!-Decidewhich device you would like to use as your karaoke viewing screen (iPad,iPhone, Android, or Laptop)-Turnon your device, and the speaker and Pair the Two using the Bluetooth Feature.Next go to on your device.-Typewhichever Song name + the word Karaoke you would like to sing into the YouTubeSearch Field.-Adjustthe volume of the speaker and/or microphones as you see fit.Nowyoure ready to Rock out with Rockville!!!Howwe came up with this concept:InThe U.S. Karaoke's Popularity continues to grow. What we did was take anAwesome! Past time and turn it into an Amazing experience entire Families andfriends can enjoy! Most karaoke machines on the market are either veryexpensive, or the cheaper ones do not sound great. They also require you to buythese CD-G discs to get the words onto a TV screen. Using youtube.com putsalmost any song you could Think of at Your Fingertips!No need to buy and/orstore Discs!These discs are hard to find and can get Pricey. I thought theremust be a better way. Soon after Rockville's Tailgate Karaoke was Born! Advantages OfOur System:-Bluetooth Ready-2 Wireless Mics-Quick and EasySet up-All NecessaryCables required for Easy Set upPackage Includes: (1) Rockville BPA15 15\" Professional Powered Active 800w DJ PA Speaker (1) Rockville RWM1203VH VHF Wireless Dual HandHeld Microphone System/Digital Display (1) Rockville RCDR10B 10' Dual RCA to Dual RCA Pro Audio Cable 100% Copper (1) Rockville RNRMR10 10' 3.5mm 1/8\" TRS to Dual RCA Cable Video ofYoutube Karaoke:All About BPA15:.",
        ingredients: null,
        image: "https://images.barcodelookup.com/26002/260026168-1.jpg",
        onlineStores: [
          {
            name: "Walmart",
            price: "$242.85",
            url: "https://www.walmart.com/ip/Rockville-Powered-15-Karaoke-System-Pro-Machine-4-ipad-iphone-Android-Laptop-TV/771328526",
          },
          {
            name: "Rockville",
            price: "$242.85",
            url: "https://www.rockvilleaudio.com/bpa15kar/",
          },
        ],
        upc: "613816023462",
        classifications: [
          "Audio",
          "Audio Players & Recorders",
          "Karaoke Systems",
        ],
        found: true,
      },
      {
        name: "RYOBI Titanium Coated Steel Drill and Drive Kit (103-Piece) and Impact Rated Driving Kit (30-Piece)",
        rating: 4.5,
        description:
          "Ryobi introduces the Titanium Coated Steel Drill and Drive Kit (103-Piece) and Impact Rated Driving Kit (30-Piece). The 103-Piece Drill and Drive Kit is great for around the house or on the jobsite. It includes drill bits that have a titanium finish to extend the life of the bit, as well as a variety of driving bits. The 103-piece. Drill and Drive Kit includes a durable hard plastic storage case for transporting and storage. The Ryobi 30-Piece Impact Rated Driving Bits are built to withstand the tough demand that comes with the use of an impact driver. The 2 in. bits feature a TORSION ZONE that is engineered to absorb the high torque and demand that comes with the use of an impact driver. This 30-piece kit offers a variety of the most commonly used 1 in. and 2 in. bits, along with specialty socket adaptors, nut drivers and bit holder. The included case is compact and modular, meaning the bit holders can be removed or rearranged. This allows for complete customization of accessory kits. This kit includes 30 bits in sizes 1 in. and 2 in. long.",
        ingredients: null,
        image: "https://images.barcodelookup.com/20066/200663618-1.jpg",
        onlineStores: [
          {
            name: "The Home Depot",
            price: "$24.85",
            url: "https://www.homedepot.com/p/RYOBI-Titanium-Coated-Steel-Drill-and-Drive-Kit-103-Piece-and-Impact-Rated-Driving-Kit-30-Piece-A981033QP-AR2037/313307155",
          },
        ],
        upc: "033287191956",
        classifications: [
          "Tool Accessories",
          "Drill & Screwdriver Accessories",
          "Drill & Screwdriver Bits",
        ],
        found: true,
      },
      {
        name: "Dylan Blue by Versace Eau De Toilette Spray 6.7 Oz (Pack of 5)",
        rating: 4.5,
        description:
          "Dylan Blue by Versace Eau De Toilette Spray 6.7 oz (Pack of 5) condition: New Brand: Versace MPN: Does not apply.",
        ingredients: null,
        image: "https://images.barcodelookup.com/15112/151129881-1.jpg",
        onlineStores: null,
        upc: "818253779570",
        classifications: ["Personal Care", "Cosmetics", "Perfume & Cologne"],
        found: true,
      },
      {
        name: "Pink Floyd Wish You Were Here 36x24 Music Art Print Poster British Progressive Rock Band Pink Floyd 9th Album",
        rating: 4.5,
        description:
          "Pink Floyd Wish you Were Here 36x24 Music Art Print Poster Wall Decor British progressive rock band Pink Floyd 9th Album.",
        ingredients: null,
        image: "https://images.barcodelookup.com/5084/50848879-1.jpg",
        onlineStores: [
          {
            name: "Walmart",
            price: "$15.99",
            url: "https://www.walmart.com/ip/Pink-Floyd-Wish-you-Were-Here-36x24-Music-Art-Print-Poster-British-progressive-rock-band-Pink-Floyd-9th-Album/124850016",
          },
        ],
        upc: "786024849664",
        classifications: [
          "General Office Supplies",
          "Paper Products",
          "Stationery",
        ],
        found: true,
      },
      {
        name: "Pentel Hi-Polymer Eraser Large Nonabrasive White ZEH10",
        rating: 4.5,
        description:
          "Pentel Hi-Polymer latex-free erasers leave a clean sheet with very little pressure. Pentel Hi-Polymer latex-free erasers are nontoxic for school use. These high-quality everyday erasers keep pages clean and free of damage thanks to latex-free polyvinyl chloride that doesn t get brittle or harden over time. With very little pressure the eraser removes pencil marks without leaving behind any dust or debris making pages easier to read without any smudges on them. Large erasers fit easily into small hands so kids have a better time erasing any wayward pencil marks. • Block-style white eraser to use in school or work. • Everyday use for pencil marks. • Pack of one eraser. • Certified nontoxic for school use. • No smudges no paper tears and no ghosting. • Doesn t crack or harden with age; remains soft and ready to use. • Eraser always looks clean - black color hides the lead residue. • Eraser should be used and stored with protective sleeve. • AP certified nontoxic. • 1 eraser per pack. • White. • Size: Large. • Latex-free. • Material: Polymer. • Sold as each. • Erases cleanly. • Non-abrasive. Easy to Use The eraser doesn t leave behind any dust nor does it damage the paper due to high-quality materials and a very light pressure needed to erase pencil marks. This is ideal for writing or artwork that needs a delicate touch without leaving behind a mess. Long-Lasting Less pressure on the eraser helps it to last longer while kids don t spend a lot of time erasing their pencil marks. The latex-free polyvinyl chloride doesn t harden or crack with age and it remains soft and ready-to-use at any time. Use and store this eraser with its protective sleeve to ensure its longevity flexibility and high-quality erasing capabilities. Ideal for Kids Pentel s Hi-Polymer eraser is certified nontoxic so children can use it for everyday schoolwork that requires a pencil. Think spelling tests artwork with colored pencils and spontaneous quizz.",
        ingredients: null,
        image: "https://images.barcodelookup.com/1102/11026068-1.jpg",
        onlineStores: [
          {
            name: "Zoro",
            price: "$1.49",
            url: "https://www.zoro.com/c/i/G7485919/",
          },
          {
            name: "Target",
            price: "$2.19",
            url: "https://www.target.com/p/pentel-hi-polymer-erasers-4ct/-/A-13296292",
          },
          {
            name: "Office Depot and OfficeMax",
            price: "$1.69",
            url: "https://www.officedepot.com/a/products/772089/Pentel-Hi-Polymer-Eraser-Lead-Pencil/",
          },
          {
            name: "Staples",
            price: "$1.69",
            url: "https://www.staples.com/pentel-hi-polymer-latex-free-eraser-each-zeh-10/product_PENZEH10?cid=BNR:PENZEH10",
          },
          {
            name: "GoVets",
            price: "$1.79",
            url: "https://www.govets.com/pentel-312-772089.html?",
          },
          {
            name: "Quill",
            price: "$3.99",
            url: "https://www.quill.com/mcode?m=AFF_PRD_012803",
          },
        ],
        upc: "072512027660",
        classifications: [
          "Office Supplies",
          "General Office Supplies",
          "Erasers",
        ],
        found: true,
      },
      {
        name: "Factory-Reconditioned Milwaukee 1670-8 7.5 Amp 1/2-Inch Hole Hawg Joist and Stud Drill",
        rating: 4.5,
        description: null,
        ingredients: null,
        image: "https://images.barcodelookup.com/5003/50036945-1.jpg",
        onlineStores: null,
        upc: "045242990474",
        classifications: [
          "Hardware Accessories",
          "Hardware Fasteners",
          "Screws",
        ],
        found: true,
      },
      {
        name: "Thermos 12oz FUNtainer Water Bottle with Bail Handle - Gray Waves",
        rating: 4.5,
        description:
          "Kids love FUNtainer products from Thermos brand, but parents love them even more. The FUNtainer 12oz Vacuum Insulated Stainless Steel Water Bottle with a silicone straw keeps drinks cold for up to 12 hours. No make believe required. FUNtainer products are always made with love from BPA-free materials. The double wall stainless steel construction is built to handle drops, dings and assorted roughhousing. The 12oz bottle includes an integrated carry handle with soft-touch grip, making it easy for kids to carry with them throughout the day. The handle can also be folded down when not in use. Help keep germs away with the hygienically covered straw which is removable for easy cleaning. To clean, you can pop your FUNtainer water bottle in the dishwasher; however hand washing is rmended. Not for use with hot liquids.",
        ingredients: null,
        image: "https://images.barcodelookup.com/25018/250188493-1.jpg",
        onlineStores: [
          {
            name: "Target",
            price: "$14.44",
            url: "https://www.target.com/p/thermos-12oz-funtainer-water-bottle-with-bail-handle-gray-waves/-/A-80138105",
          },
          {
            name: "Overstock.com",
            price: "$19.75",
            url: "https://www.overstock.com/Sports-Toys/Camp-Kitchen/13124/subcat.html?featuredproduct=34416952",
          },
        ],
        upc: "041205751793",
        classifications: [
          "Home & Garden",
          "Kitchen & Dining",
          "Food & Beverage Carriers",
        ],
        found: true,
      },
      {
        name: "Replacement Battery for Ryobi 18V 4000mah/5000mah/6000mah Li-ion for Ryobi One+ P103 /P108 Cordless Drill Kit Rechargeable Battery Pack Power Tools",
        rating: 4.5,
        description:
          "Please note, this item ships from an international seller. Expected delivery is 10-15 days.Features:This parts is used for Ryobi 18-Volt ONE+ Tools.100% suitable for ryobi battery.Built-in Cells to provides optimized performance and overload protection using total system communication between Handheld Vacuum, battery and.Powilling products are made with the highest quality materials.All Powilling battery packs comply with RoHS and CE testing standards.LED Indicator light can show the remaining power, can control the amount of power at any time,ensure that work is done without recharging.Specifications:Voltage: 18VCapacity: 4000mah / 5000mah / 6000mahoptionalMaterial: Type of battery: Li-ionColor: Black+YellowBattery cell standard18650 20APacking: CartonCharging room temp: 10~40Package Size: 13.5*11.5*9.5cm / 5.3*4.5*3.7inPackage Weight: 734g / 25.9ozCompatible ModelRYOBI P108 BPL-1815, BPL-1820G, BPL18151, BPL1820, P102, P103 P104, P105, P106, P107RYOBI BPL-1815, BPL-1820G, BPL18151, BPL1820, P102, P103 P104, P105, P106, P107RYOBI ONE+ 18 Volt Cordless Drill Power Tool BID-1801M, BID-180L, BID1821, BIW180, CAD-180L,CAG-180M, CAP-1801M, CCC-1801M, CCC-180L, CCD-1801, CCG-1801M, CCG-180L, CCS-1801/DM, CCS-1801/LM, CCS-1801D, CCS-1801LM, CCW-180L, CDA-18021B, CDA1802, CDA18021B, CDA18022B, CDA1802M, CDC-181M, CDI-1802, CDI-1802M, CDI-1803, CDI-1803M, CFA-180M, CFP-180FM, CFP-180S, CFP-180SM, CHD-1801M, CHI-1802M, CHP-1802M, CHV-180L, CHV-18WDM, CID-1802M, CID-1803L, CID-1803M, CID-182L, CID-183L, CJS-180L, CJS-180LM, CJSP-1801QEOM, CJSP-180QEO, CJSP-180QEOM, CMD-1802, CMD-1802M, CMI-1802,CMI-1802M, CML-180M, CNS-1801M, CNS-180L, CP-180M, CPD-1800, CPL-180M, CRA-180M, CRH1801, CRO-180M, CRP-1801, CRP-1801/DM, CRP-1801D, CRS 1803, CRS-180L, CSL-180L, CSS-1801M, CSS-180L, CST-180M, CTR-180L, CW-1800, LCD1802, LCD18021B, LCD18022B, LCD1802M, LCS-180, LDD-1802, LDD-1802PB, LDD1801PB, LDD1802PB, LFP-1802S, LRS-180, OBL-1801, OCS-1840, OGS-1820, OHT-1850, OLT-1830,OPS-1820, ORS-1801, OWD-1801M, P200, P2000, P2002, P201, P203, P204, P206, P2060, P208B, P210, P2100, P2102, P2105, P211, P220, P221, P230, P234G, P236, P240, P2400, P241, P246, P250, P2500, P2600, P2603, P271, P300, P301, P310, P3200, P3300, P3310, P340, P400, P410, P420, P430, P500, P501, P506, P510, P514, P520, P521, P522, P530, P540, P570, P600, P610, P631K, P650, P700, P701G, P703, P704, P710, P711, P715, P716, P730, P731, P740, P741, P780, P813, P835Safety instruction for the :1.Keep the charge dry,It may increase the risk of electric shock in conditon2.Don't charge other batteries,this is only suitable for the specific voltage range batteries listed on the details page.3.Keep the,contamination may increase the risk of electric shock.4.Check the,cable and plug before access,if defects are found,don't use the.don't suggest to open the privately unless a qualified person who will use spare parts.5.The would heat,please keep it way from combustible surrounding when using.6.Power the with listed voltage range power supply on the 7.Unplug when attempting to the.8.Unplug the when not using to short circuit9.Don't touch the uninsulated portion of output connector or uninsulated batter terminal10.For safe operation,see instruction manual,use high capacity.Package List:1 * Battery.",
        ingredients: null,
        image: "https://images.barcodelookup.com/18047/180475923-1.jpg",
        onlineStores: [
          {
            name: "Walmart",
            price: "$48.28",
            url: "https://www.walmart.com/ip/Replacement-Battery-for-Ryobi-18V-4000mah-5000mah-6000mah-Li-ion-for-Ryobi-One-P103-P108-Cordless-Drill-Kit-Rechargeable-Battery-Pack-Power-Tools/28507574",
          },
        ],
        upc: "791327117525",
        classifications: [
          "Home & Garden",
          "Business & Home Security",
          "Home Alarm Systems",
        ],
        found: true,
      },
      {
        name: "Ryobi Power Tool Battery 18-Volt 9.0 Ah Lithium-Ion Rechargeable Black (2-Pack)",
        rating: 4.5,
        description:
          "Ryobi Power Tool Battery 18-Volt 9.0 Ah Lithium-Ion Rechargeable Black (2-Pack) condition: New EAN: Does not apply Battery Voltage: 18 V Brand: Ryobi Model: P168 MPN: P168 Battery Capacity: 2 Ah Type: Battery Battery Technology: Lithium-Ion (Li-Ion) Voltage: 18 V.",
        ingredients: null,
        image: "https://images.barcodelookup.com/17005/170057061-1.jpg",
        onlineStores: null,
        upc: "993245226833",
        classifications: [
          "Hardware",
          "Tool Accessories",
          "Power Tool Batteries",
        ],
        found: true,
      },*/

    ],
  };
};

export default db;
